"use client"

import { isFullPageModalOpenAtom } from "@/app/contexts/Atoms"
import useBaseBlogUrl from "@/app/hooks/useBaseBlogUrl"
import { useAtom } from "jotai"
import { MoveRight } from "lucide-react"
import Link from "next/link"
import useDismissModal from "../hooks/useDismissModal"

const MoveRightComponent = () => (
  <MoveRight className=" ml-1 h-5 w-5 inline font-normal " />
)

/**
 * LoginCTA component for the subscribe flow.
 *
 * This can be called in multiple ways:
 *
 * - via the /blog/subscribe page
 * - via the "Subscribe" button, which intercepts the route and opens a modal
 * - via the full-page subscribe takeover, which uses a Jotai atom to control the modal state
 */
export default function LoginCTA() {
  // If the modal is open (eg, we're calling it in the context of a full-page takeover),
  // we don't want to link to the blog post, we want to close the modal instead.
  const [isFullPageModalOpen, setIsFullPageModalOpen] = useAtom(
    isFullPageModalOpenAtom
  )
  const closeModal = useDismissModal("LoginCTA")
  const blogSlugUrl = useBaseBlogUrl()

  return (
    <>
      <div className="my-4" />

      <div className="text-center text-sm text-muted-foreground font-semibold hover:text-slate-400 transition-all align-middle items-center justify-center">
        {isFullPageModalOpen ? (
          <div
            className="cursor-pointer"
            onClick={() => {
              closeModal()
            }}
          >
            Read it first
            <MoveRightComponent />
          </div>
        ) : blogSlugUrl ? (
          <Link
            href={blogSlugUrl}
            className="cursor-pointer"
            onClick={() => closeModal()}
          >
            Read it first
            <MoveRightComponent />
          </Link>
        ) : null}
      </div>
    </>
  )
}
